import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledActionLink = styled(Link)`
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: 0 none;

  ${({ disabled }) => disabled &&
    `
      opacity: 0.5;
      text-decoration: none;
      cursor: default;
    `
  }

  &:hover {
    text-decoration: none;
  }
`;

export const StyledSvg = styled.svg`
  ${({ smallIcon }) => smallIcon ?
    'vertical-align: text-top;'
  :
    `
      width: 1.250em;
      height: 1.250em;
      vertical-align: middle;
      margin-right: 0.313em;
    `}
`;
StyledSvg.displayName = 'StyledSvg';


const ActionLink = (props) => {
  const {
    href,
    icon,
    smallIcon,
    label,
    onClick,
    disabled = false,
    hidden,
    className,
    children
  } = props;

  if (hidden) return null;

  const click = (disabled) ? () => null : onClick;
  const qaHook = (props['data-qa-hook']) ? { 'data-qa-hook': props['data-qa-hook'] } : null;
  const ariaLabel = (props['aria-label']) ? { 'aria-label': props['aria-label'] } : null;
  const path = disabled ? '#' : href;

  // add proper keyboard support to Links with #
  const accessibleClick = (e) => e.keyCode === 13 && e.target.click();

  const linkOrButtonProps = href == null
    ? {
      as: 'button',
      type: 'button'
    }
    : {
      to: path
    };


  return (
    <StyledActionLink
      {...linkOrButtonProps}
      className={className}
      disabled={disabled}
      onKeyUp={accessibleClick}
      onClick={click}
      {...qaHook}
      {...ariaLabel}
    >
      {icon && <StyledSvg smallIcon={smallIcon}><use xlinkHref={icon} /></StyledSvg>}
      {label ?? children}
    </StyledActionLink>
  );
};

const { node, string, func, bool } = PropTypes;

ActionLink.propTypes = {
  'data-qa-hook': string,
  className: string,
  href: string,
  icon: node,
  label: string,
  onClick: func,
  disabled: bool,
  hidden: bool,
  children: node,
  'aria-label': string
};

export default ActionLink;
